import Vue from 'vue';
import axios from 'axios';
import store from '@/store';
// import router from "@/router";
// import router from '@/router/index';

// Check Auth && Set Token To Header
if (store.getters['auth/isAuth']) {
  axios.defaults.headers.common.Authorization = `Bearer ${store.getters['auth/token']}`;
  axios.defaults.headers.common['Content-Language'] = 'la';
}
export const $axios = axios.create(
  {
    baseURL: process.env.VUE_APP_BASE_API_URL,
  },
);
export const normalAxios = axios.create(
  {
    baseURL: process.env.VUE_APP_BASE_URL,
  },
);

// const apiUrl = process.env['VUE_APP_BASE_API_URL'];
// export {
//     apiUrl
// }

$axios.interceptors.response.use((response) => response,
  (error) => {
    if (error.response) {
    // Token expired
      if (error.response.status == 401) {
        store.commit('modalCheckToken_State', true);
      }
      // Missing permission: the token is still valid, so don't log the user
      // out. Show the server's message instead. Background calls can pass
      // `silentForbidden: true` in their axios config to stay quiet.
      if (error.response.status == 403 && !(error.config && error.config.silentForbidden)) {
        const msg = (error.response.data && error.response.data.message) || 'ບໍ່ມີສິດເຂົ້າເຖິງ';
        store.commit('Toast_State', { value: true, color: 'error', msg });
      }
    }

    return Promise.reject(error);
  });

Vue.prototype.$axios = $axios;
Vue.prototype.$http = normalAxios;
